/**
 * LOCAL TESTING VERSION of generate-content API
 * 
 * This is a simplified version for local testing without OpenAI.
 * The real version is in /api/generate-content.ts and runs on Vercel.
 * 
 * To use this locally:
 * 1. Import this function in your component
 * 2. Call it directly instead of fetching /api/generate-content
 */

import { createArticle } from '../lib/supabase';

export const localGenerateContent = async () => {
  try {
    // Generate a mock article for testing
    const mockArticle = {
      title: `Test Article - ${new Date().toLocaleDateString()}`,
      slug: `test-article-${Date.now()}`,
      excerpt: 'This is a test article generated locally for development purposes. It demonstrates the article creation flow without requiring OpenAI API.',
      content: `# Test Article

This is a **test article** generated locally for development purposes.

## Features Demonstrated

- Article creation
- Slug generation
- Markdown content
- Database insertion

## Code Example

\`\`\`javascript
const testFunction = () => {
  console.log('Hello from test article!');
};
\`\`\`

## Conclusion

This article was created to test the content generation system without requiring external API calls.`,
      tags: ['test', 'development', 'local'],
      reading_time: 5,
      is_published: false,
      is_ai_generated: false,
      author: 'Kevyn Franco',
    };

    // Save to database
    const savedArticle = await createArticle(mockArticle);

    return {
      success: true,
      message: 'Test article created successfully',
      data: {
        // @ts-ignore - Type inference issue
        article_id: savedArticle.id,
        title: mockArticle.title,
        slug: mockArticle.slug,
      },
    };
  } catch (error: any) {
    console.error('Error creating test article:', error);
    return {
      success: false,
      message: error.message || 'Failed to create test article',
    };
  }
};